import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Block as BlockIcon } from '@mui/icons-material';
import {
  UnauthorizedContainer,
  ContentWrapper,
  IconWrapper,
  TitleText,
  MessageText,
  ButtonsContainer,
  StyledButton,
} from './styles';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleContact = () => {
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <UnauthorizedContainer>
      <ContentWrapper>
        <IconWrapper>
          <BlockIcon sx={{ fontSize: 40 }} />
        </IconWrapper>
        
        <TitleText>Acesso não autorizado</TitleText>
        
        <MessageText>
          Você não tem permissão para acessar esta página ou recurso. 
          Se você acredita que isso é um erro, entre em contato com o administrador do sistema.
        </MessageText>
        
        <ButtonsContainer>
          <StyledButton 
            className="secondary"
            onClick={handleLogout}
          >
            Sair
          </StyledButton>
          
          <StyledButton 
            className="primary"
            onClick={handleLogin}
          >
            Entrar com outra conta
          </StyledButton>
        </ButtonsContainer>
      </ContentWrapper>
    </UnauthorizedContainer>
  );
};

export default UnauthorizedPage;
